export const FILTER_TYPE = {
  Purchases: 'Purchases',
  Withdrawals: 'Redeem',
}
